



























































































import { base64UrlEncode, copyTextToClipboard, random, rot13 } from 'vtils'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { getPageUrl } from '@/router'
import { Toast } from 'vant'

export default defineClassComponent(
  () =>
    class {
      pageTitle = ref('')

      testResourcePositionId = ref('')

      prodResourcePositionId = ref('')

      testSharePosterId = ref('')

      prodSharePosterId = ref('')

      testUseSharePosterUrl = ref(false)

      prodUseSharePosterUrl = ref(false)

      testQ = computed(() =>
        rot13(
          base64UrlEncode(
            JSON.stringify({
              r: random(1, 100),
              pageTitle: this.pageTitle.value,
              resourcePositionId: this.testResourcePositionId.value,
              sharePosterId: this.testSharePosterId.value || undefined,
              useSharePosterUrl: this.testUseSharePosterUrl.value
                ? '1'
                : undefined,
            }),
          ),
        ),
      )

      prodQ = computed(() =>
        rot13(
          base64UrlEncode(
            JSON.stringify({
              r: random(1, 100),
              pageTitle: this.pageTitle.value,
              resourcePositionId: this.prodResourcePositionId.value,
              sharePosterId: this.prodSharePosterId.value || undefined,
              useSharePosterUrl: this.prodUseSharePosterUrl.value
                ? '1'
                : undefined,
            }),
          ),
        ),
      )

      testPageUrl = computed(() =>
        getPageUrl(
          'ActivityIndex',
          {
            q: this.testQ.value,
          },
          'test',
        ),
      )

      prodPageUrl = computed(() =>
        getPageUrl(
          'ActivityIndex',
          {
            q: this.prodQ.value,
          },
          'prod',
        ),
      )

      testPageQrcodeUrl = computed(
        () =>
          `https://tool.oschina.net/action/qrcode/generate?data=${encodeURIComponent(
            this.testPageUrl.value,
          )}&output=image%2Fgif&error=L&type=0&margin=0&size=4&${Date.now()}`,
      )

      prodPageQrcodeUrl = computed(
        () =>
          `https://tool.oschina.net/action/qrcode/generate?data=${encodeURIComponent(
            this.prodPageUrl.value,
          )}&output=image%2Fgif&error=L&type=0&margin=0&size=4&${Date.now()}`,
      )

      handleCopyClick = (url: string) => {
        copyTextToClipboard(url)
        Toast.success('复制成功')
      }
    },
)
